class ImageField {
  constructor(el) {
    this.container = el
    this.image = this.container.querySelector('.form__picture img')
    this.input = this.container.querySelector('.form__input')

    this.imageSelected = this.imageSelected.bind(this)
    this.init()
  }

  imageSelected(e) {
    const imageField = e.target.files[0]

    const reader = new FileReader()

    reader.onloadend = () => {
      if (this.image) {
        this.image.src = reader.result
      }
    }

    if (imageField) {
      reader.readAsDataURL(imageField)
    }
  }

  init() {
    if (this.input) {
      this.input.addEventListener('change', this.imageSelected)
    }
  }
}

const imageFieldInit = {
  init() {
    const wrapperEl = document.querySelectorAll('.image-field')
    Array.from(wrapperEl).forEach(form => new ImageField(form))
  },
}

export default imageFieldInit
